// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.security-tree__header {
  border-bottom: 1px solid var(--lightgray-e);
}

.security-tree-node {
  --border-color: #000;
  border: 1px solid;
  border-color: var(--border-color);
  border-radius: 4px;
  padding: 15px;
  font-size: 11px;
  font-weight: bold;
}

.security-tree-node p {
  margin-bottom: 5px;
}

.security-tree-node hr {
  margin: 5px 0;
}

.security-tree-node--rule {
  background: var(--blue-eff);
  --border-color: var(--blue-bcc);
  width: 240px;
}

.security-tree-node--rule.security-tree-node--highlighted {
  background: var(--yellow-f);
  --border-color: var(--yellow-d);
}

.security-tree-node--policy {
  background: var(--lightgray-f);
  --border-color: var(--lightgray-c);
  width: 240px;
}

.security-tree-node--policy.security-tree-node--highlighted {
  background: var(--yellow-f);
  --border-color: var(--yellow-d);
}

.security-tree-node--highlighted {
  box-shadow: inset 0 0 0 2px var(--border-color);
}

.security-tree-node--test-group {
  background: var(--lightgray-f);
  width: 185px;
}

.security-tree-node--test-leaf {
  --border-color: var(--blue-bcc);
  background: #fff;
  width: 185px;
}

.security-tree-node--test-error {
  background: var(--red-f);
  --border-color: var(--red-d);
  width: 185px;
}

.security-tree-node--path-lookup-options {
  background: var(--blue-eff);
  --border-color: var(--blue-bcc);
  width: 300px;
}

.security-tree-node__heading {
  font-size: 13px;
}

.security-simple-test {
  border-left: 3px solid var(--lightgray-9);
  padding-left: 10px;
}

.security-simple-test--l1 {
  border-left-color: #6fb96f;
}

.security-simple-test--l3 {
  border-left-color: #b77bcc;
}

.security-simple-test--icmp {
  border-left-color: #4c061d;
}

.security-simple-test--l4 {
  border-left-color: #d17a22;
}

.security-simple-test--l7 {
  border-left-color: #0081a7;
}

.security-simple-test--options {
  border-left-color: #9dfff9;
}

.security-simple-test--processing {
  border-left-color: #fed9b7;
}

.security-simple-test--vxlan {
  border-left-color: #d4b524;
}

.security-simple-test--eth {
  border-left-color: #7aa3cc;
}

.security-simple-test--mpls {
  border-left-color: #f4e87c;
}

.security-tree__connection-lines--and {
  color: var(--warning);
}

.security-tree__connection-lines--not {
  color: var(--danger);
}

.security-tree__connection-lines--or {
  color: var(--info);
}

.security-tree-node--and {
  --border-color: var(--warning);
}

.security-tree-node--not {
  --border-color: var(--danger);
}

.security-tree-node--or {
  --border-color: var(--info);
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/SecuritySchema/styles.css","webpack://./services/frontend/app/components/SecuritySchema/styles.css"],"names":[],"mappings":"AADA;ECEE,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".security-tree__header {\n  border-bottom: 1px solid var(--lightgray-e);\n}\n\n.security-tree-node {\n  border: 1px solid;\n  /* just unused default to clear vars from outer scope, all node types should have border color defined */\n  --border-color: #000;\n\n  border-color: var(--border-color);\n  border-radius: 4px;\n  padding: 15px;\n  font-weight: bold;\n  font-size: 11px;\n}\n\n.security-tree-node p {\n    margin-bottom: 5px;\n  }\n\n.security-tree-node hr {\n    margin: 5px 0;\n  }\n\n.security-tree-node--rule {\n  background: var(--blue-eff);\n\n  --border-color: var(--blue-bcc);\n\n  width: 240px;\n}\n\n.security-tree-node--rule.security-tree-node--highlighted {\n    background: var(--yellow-f);\n\n    --border-color: var(--yellow-d);\n  }\n\n.security-tree-node--policy {\n  background: var(--lightgray-f);\n\n  --border-color: var(--lightgray-c);\n\n  width: 240px;\n}\n\n/* same \"this is what decided\" yellow a highlighted rule gets */\n\n.security-tree-node--policy.security-tree-node--highlighted {\n    background: var(--yellow-f);\n\n    --border-color: var(--yellow-d);\n  }\n\n.security-tree-node--highlighted {\n  box-shadow: inset 0 0 0 2px var(--border-color);\n}\n\n.security-tree-node--test-group {\n  background: var(--lightgray-f);\n  width: 185px;\n}\n\n.security-tree-node--test-leaf {\n  background: #fff;\n\n  --border-color: var(--blue-bcc);\n\n  width: 185px;\n}\n\n.security-tree-node--test-error {\n  background: var(--red-f);\n\n  --border-color: var(--red-d);\n\n  width: 185px;\n}\n\n.security-tree-node--path-lookup-options {\n  background: var(--blue-eff);\n\n  --border-color: var(--blue-bcc);\n\n  width: 300px;\n}\n\n.security-tree-node__heading {\n  font-size: 13px;\n}\n\n.security-simple-test {\n  padding-left: 10px;\n  border-left: 3px solid var(--lightgray-9);\n}\n\n/* colors are intentionally literal here - this is a specific */\n\n/* palette for security headers */\n\n.security-simple-test--l1 {\n  border-left-color: #6fb96f;\n}\n\n.security-simple-test--l3 {\n  border-left-color: #b77bcc;\n}\n\n.security-simple-test--icmp {\n  border-left-color: #4c061d;\n}\n\n.security-simple-test--l4 {\n  border-left-color: #d17a22;\n}\n\n.security-simple-test--l7 {\n  border-left-color: #0081a7;\n}\n\n.security-simple-test--options {\n  border-left-color: #9dfff9;\n}\n\n.security-simple-test--processing {\n  border-left-color: #fed9b7;\n}\n\n.security-simple-test--vxlan {\n  border-left-color: #d4b524;\n}\n\n.security-simple-test--eth {\n  border-left-color: #7aa3cc;\n}\n\n.security-simple-test--mpls {\n  border-left-color: #f4e87c;\n}\n\n.security-tree__connection-lines--and {\n  color: var(--warning);\n}\n\n.security-tree__connection-lines--not {\n  color: var(--danger);\n}\n\n.security-tree__connection-lines--or {\n  color: var(--info);\n}\n\n.security-tree-node--and {\n  --border-color: var(--warning);\n}\n\n.security-tree-node--not {\n  --border-color: var(--danger);\n}\n\n.security-tree-node--or {\n  --border-color: var(--info);\n}\n",".security-tree__header {\n  border-bottom: 1px solid var(--lightgray-e);\n}\n\n.security-tree-node {\n  --border-color: #000;\n  border: 1px solid;\n  border-color: var(--border-color);\n  border-radius: 4px;\n  padding: 15px;\n  font-size: 11px;\n  font-weight: bold;\n}\n\n.security-tree-node p {\n  margin-bottom: 5px;\n}\n\n.security-tree-node hr {\n  margin: 5px 0;\n}\n\n.security-tree-node--rule {\n  background: var(--blue-eff);\n  --border-color: var(--blue-bcc);\n  width: 240px;\n}\n\n.security-tree-node--rule.security-tree-node--highlighted {\n  background: var(--yellow-f);\n  --border-color: var(--yellow-d);\n}\n\n.security-tree-node--policy {\n  background: var(--lightgray-f);\n  --border-color: var(--lightgray-c);\n  width: 240px;\n}\n\n.security-tree-node--policy.security-tree-node--highlighted {\n  background: var(--yellow-f);\n  --border-color: var(--yellow-d);\n}\n\n.security-tree-node--highlighted {\n  box-shadow: inset 0 0 0 2px var(--border-color);\n}\n\n.security-tree-node--test-group {\n  background: var(--lightgray-f);\n  width: 185px;\n}\n\n.security-tree-node--test-leaf {\n  --border-color: var(--blue-bcc);\n  background: #fff;\n  width: 185px;\n}\n\n.security-tree-node--test-error {\n  background: var(--red-f);\n  --border-color: var(--red-d);\n  width: 185px;\n}\n\n.security-tree-node--path-lookup-options {\n  background: var(--blue-eff);\n  --border-color: var(--blue-bcc);\n  width: 300px;\n}\n\n.security-tree-node__heading {\n  font-size: 13px;\n}\n\n.security-simple-test {\n  border-left: 3px solid var(--lightgray-9);\n  padding-left: 10px;\n}\n\n.security-simple-test--l1 {\n  border-left-color: #6fb96f;\n}\n\n.security-simple-test--l3 {\n  border-left-color: #b77bcc;\n}\n\n.security-simple-test--icmp {\n  border-left-color: #4c061d;\n}\n\n.security-simple-test--l4 {\n  border-left-color: #d17a22;\n}\n\n.security-simple-test--l7 {\n  border-left-color: #0081a7;\n}\n\n.security-simple-test--options {\n  border-left-color: #9dfff9;\n}\n\n.security-simple-test--processing {\n  border-left-color: #fed9b7;\n}\n\n.security-simple-test--vxlan {\n  border-left-color: #d4b524;\n}\n\n.security-simple-test--eth {\n  border-left-color: #7aa3cc;\n}\n\n.security-simple-test--mpls {\n  border-left-color: #f4e87c;\n}\n\n.security-tree__connection-lines--and {\n  color: var(--warning);\n}\n\n.security-tree__connection-lines--not {\n  color: var(--danger);\n}\n\n.security-tree__connection-lines--or {\n  color: var(--info);\n}\n\n.security-tree-node--and {\n  --border-color: var(--warning);\n}\n\n.security-tree-node--not {\n  --border-color: var(--danger);\n}\n\n.security-tree-node--or {\n  --border-color: var(--info);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
